module.exports = new __parcel__URL__("raccoon.16b4372e.svg").toString();